module.exports = __webpack_public_path__ + "images/moonshot/bc-sparkle.bd904266f6bf970d90a5.svg";